import { withResult } from 'feathers-fletching';
import { statusType, truckType } from 'straightline-utils/constants';

const withResults = withResult({
  shipment: async ({ shipment }, context) => {
    if (!shipment) {
      return shipment;
    }

    shipment = { ...shipment };

    shipment.status = statusType(shipment.status_type);
    shipment.truck = truckType(shipment.truck_type);

    shipment.pickup_address = {
      ...shipment.pickup_address,
      position: {
        lat: Number(shipment.pickup_address.latitude),
        lng: Number(shipment.pickup_address.longitude)
      }
    };

    shipment.delivery_address = {
      ...shipment.delivery_address,
      position: {
        lat: Number(shipment.delivery_address.latitude),
        lng: Number(shipment.delivery_address.longitude)
      }
    };

    return shipment;
  }
});

export default {
  before: {
    get: []
  },
  after: {
    get: [withResults]
  },
  error: {
    get: []
  }
};
